import {
  Component,
  OnInit,
  Directive,
  ElementRef,
  Input,
  HostListener
} from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DomSanitizer } from "@angular/platform-browser";
import { DataService } from "../../services/data.service"
import { InProductsService } from "../../services/inventory/in-products.service";
import { InToolsService } from "../../services/inventory/in-tools.service";
import { AuthenticationService } from "../../services/authentication.service";
import { environment } from "../../../../environments/environment";
import { forEach } from "@angular/router/src/utils/collection";
import { InPurchasesService } from "../../services/inventory/in-purchases.service";
import { MasterService } from "../../services/inventory/master.service";

export interface ItemsMaster {
  title: string;
  Items: any;
}

@Component({
  selector: 'app-add-item',
  templateUrl: './add-item.component.html',
  styleUrls: ['./add-item.component.css']
})
export class AddItemComponent extends DialogComponent<ItemsMaster, boolean>
  implements ItemsMaster, OnInit {

  title: string;
  Items: any;
  result: any = { result: false, RtnItem: {} };
  loading: boolean = false
  model =new Import_Master();
  ItemId:number=0;
  supplierList: any=[];
  unitList: any=[];
  ItemAutoGenerate:boolean=false;

  constructor(dialogService: DialogService, private sanitizer: DomSanitizer, private ds: DataService, private ps: InPurchasesService,
    private ips: InProductsService, private aut: AuthenticationService,private ts: InToolsService,private ms: MasterService,) {
    super(dialogService);
  }

  ngOnInit() {
    var t = this.ds.Settings.AutoCreateItemMasterData
    this.ItemAutoGenerate = t.toLowerCase() == 'true'
    this.clear();   

    this.getUnits();
  }
 
  clear() {
    this.model = new Import_Master();
    this.loading=false;
  }

  genBarcode(){
    this.loading=true;
    this.ips.getItemId().subscribe(res => {
      if (res.Success) {
        this.ItemId= res.data;
      }
    },
      (err) => console.error(err),
      () => {
        var model_barcodeGen = {
          IID: this.ItemId,
          NoofBarcodeDigits: 13,
          itemMasterStartNo: this.ds.Settings.ItemmasterStartNo.toString(),
          UserNo: this.ds.Settings.UserNo.toString(),
          itemMasterTypeID: this.ds.Settings.ItemTypeId,
          WeighingScaleitems: false,
          isMasterItem: true,
          ItemCount: 0
        };
        this.ips.GenBarcode(model_barcodeGen).subscribe(res => {
          this.model.Barcode = res.data;
          document.getElementById("txtItemName").focus();
        })
      });
      this.loading=false;
  }

  translate() {
    var textfilter: any = {
      Text: this.model.ProductName,
      ToLang: ""
    }
    this.ips.Translate(textfilter).subscribe(res => {
      if (res.Success) {
        this.model.ArabicName = res.data
      }
    }
    )
  }

  getUnits() {
    var filterData = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: 1,
      CAType: 1
    };
    this.loading=true;
    this.ms.GetUnit(filterData).subscribe(
      res => {
        this.unitList = [];
        for (let i of res.data) {
          this.unitList.push({
            Id: i.Id,
            Name: i.Name
          });
        }
      },
      (err) => console.error(err),
      () => {
      }
    );
    this.loading=false;
  }

  saveItem(){
    // var r = confirm("Do you want to save this record?");
    // if (r == true) {
      this.loading=true;
      this.model.LocationId=this.ds.Settings.LocationId;
      this.model.BranchId=this.ds.Settings.BranchId;
      this.model.UserId=this.ds.Settings.UserId;
      this.model.SellingPriceLevelId=this.ds.Settings.SellingPriceLevelId;
      this.ips.Save_ImportSingleProduct(this.model).subscribe(res => {
        if (res.Success) {
          this.result.RtnItem=this.model.Barcode;
          this.result.result=true;
         // alert("Product Saved Succesfully");    
          this.clear();
          this.close();
        } else {
          alert(res.error.UsrMsg);
          this.loading=false
        }
      });
    // }   
  }

  barcodeKeydown(e){
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("txtItemName").focus();
    } 
  }
  itemnameKeydown(e){
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("Unit").focus();
    } 
  }
  // seclanguageKeydown(e){
  //   if (e.keyCode == 13 && e.which == 13) {
  //     document.getElementById("Supplier").focus();
  //   } 
  // }
  // supplierKeydown(e){
  //   if (e.keyCode == 13 && e.which == 13) {
  //     document.getElementById("Unit").focus();
  //   } 
  // }
  selectUnit(){
    document.getElementById("costprice").focus();
  }

  unitKeydown(e){
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("costprice").focus();
    } 
  }
  costpriceKeydown(e){
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("sellingprice").focus();
    } 
  }
  sellingpriceKeydown(e){
    if (e.keyCode == 13 && e.which == 13) {
      //document.getElementById("Active").focus();
    } 
  }
 
}
class Import_Master {
   ProductName : string = ""
   Barcode : string = ""
   CostPrice : number = 0.0
   SellingPrice : number = 0.0
   DepartmentId : number = 0
   CategoryId : number = 0
   SubCategoryId : number = 0
   UnitId : number = 0
   Contain : string
   BrandId : number = 0
   ShortName : string = ""
   SupplierId : number = 0
   ReferenceNumber : string = ""
   ItemID : number = 0
   ArabicName : string = ""
   ColorId : number = 0
   SizeId : number = 0
   BranchId : number = 0
   LocationId : number = 0
   SellingPriceLevelId : number = 0
   Taxcode : number = 1
   WeighingScale : boolean = false
   Active : boolean = true
   UserId :number=0;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/add-item/add-item.component.ts